export const survey_fixed_list = [
  // 'vuducminhdev07',
  '0865551568',
  '0949025665',
  'khacthanh271992@gmail.com',
  'khiemkieu3192@gmail.com',
  'khanhvd@ecomgroup.vn',
  'babyhopvn@gmail.com',
  'thanhthanhblue83@gmail.com',
  'hanaatosa4813@gmail.com',
  'vuadepvn@gmail.com',
  'noemail@sieuloinhuan.net',
  'nguyenvo28695@gmail.com',
  'huynd@atosa.asia',
  'minhbt@atosa.asia',
  'nguyenduchuy.neu@gmail.com',
  'atosa.asia@gmail.com',
  'quynhphan@thepioneer.net.vn',
  'ads.atosa01@gmail.com',
  'ads.atosa02@gmail.com',
  'ads.atosa04@gmail.com',
  'ads.atosa05@gmail.com',
  'atosa.vanhanh.02@gmail.com',
  'atosa.vanhanh.04@gmail.com',
  'atosa.vanhanh.05@gmail.com'
]

export const quota_fixed_list = [
  // 'vuducminhdev07',
  'vuadepvn@gmail.com',
  'noemail@sieuloinhuan.net',
  'backinh999@gmail.com',
  'atosa.asia@gmail.com'
]

export const shop_product_fixed_list = [
  // 'vuducminhdev07',
  'vuadepvn@gmail.com',
  'noemail@sieuloinhuan.net',
  'backinh999@gmail.com',
  'atosa.asia@gmail.com',
  'hotayxanh.net@gmail.com',
  'babyhopvn@gmail.com',
  'vuducminhdev',
  'ads.atosa',
  '.atosa@gmail.com',
  '@atosa.asia',
  'atosa.asia',
  'tuan.nguyenpartner@gmail.com',
  'atosaagency',
  'atosa.vanhanh',
  'khiemkieu3192@gmail.com'
]

export const google_volume_fixed_list = [
  'vuducminhdev07',
  'nguyenhuehrc@gmaill.com'
]

export const agency_plan_fixed_list = [
  // 'vuducminhdev',
  'ads.atosa',
  '.atosa@gmail.com',
  '@atosa.asia',
  'atosa.asia',
  'tuan.nguyenpartner@gmail.com',
  'atosaagency',
  'atosa.vanhanh',
  'khiemkieu3192@gmail.com',
  'hotayxanh.net@gmail.com',
  'ceo@julyhouse.vn'
]

export const advanced_fixed_list = [
  // 'vuducminhdev',
  // 'ads.atosa',
  // '.atosa@gmail.com',
  // '@atosa.asia',
  // 'atosa.asia',
  // 'tuan.nguyenpartner@gmail.com',
  // 'atosaagency',
  // 'atosa.vanhanh',
  // 'khiemkieu3192@gmail.com',
  // 'hotayxanh.net@gmail.com',
  // 'ceo@julyhouse.vn'
]

export const auto_cir_fixed_list = [
  // 'vuducminhdev',
  'atosa.asia@gmail.com'
]

export const date_option_fixed_list = [
  'vuducminhdev',
  'ads.atosa',
  '.atosa@gmail.com',
  '@atosa.asia',
  'atosa.asia',
  'tuan.nguyenpartner@gmail.com',
  'atosaagency',
  'atosa.vanhanh',
  'khiemkieu3192@gmail.com',
  'ceo@julyhouse.vn'
]

export const check_multiple_position_fixed_list = [
  'vuducminhdev',
  'ads.atosa',
  '.atosa@gmail.com',
  '@atosa.asia',
  'atosa.asia',
  'atosaagency',
  'atosa.vanhanh',
  'hotayxanh.net@gmail.com',
  'ceo@julyhouse.vn',
  'khiemkieu3192@gmail.com'
]

export const atosa_advanced_fixed_list = [
  'vuducminhdev',
  'atosa.asia',
  'ceo@julyhouse.vn',
  'khiemkieu3192@gmail.com',
  'tuannd2107cpqn@gmail.com',
  'ngchihung1988@gmail.com',
  'raacus.obm@gmail.com'
]

export const douyin_fixed_list = [
  'vuducminhdev07',
  'ads.atosa14@gmail.com',
  'lilyeyewear0911@gmail.com',
  'atoxon@atosa.asia'
]

export const auto_optimize_fixed_list = [
  'vuducminhdev07',
  'ads.atosa04@gmail.com',
  'rosa210379@gmail.com'
]

export const flash_sale_advanced_list = [
  'vuducminhdev07',
  'curravn@gmail.com',
  'atoxon@atosa.asia',
  'ads.atosa14@gmail.com',
  '0934824608',
  'umihavietnam@gmail.com',
  'khiemkieu3192@gmail.com',
  'vietvh2109@gmail.com',
  'vietnamrich@gmail.com',
  'longbuixcxt228@gmail.com'
]

export const quick_view_fixed_list = [
  'khiemkieu3192@gmail.com',
  '0934824608',
  'ads.atosa14@gmail.com'
]

export const connect_platform_fixed_list = [
  'vuducminhdev07',
  'ads.atosa14@gmail.com',
  'quynhtramtrinh2023@gmail.com',
  'commerce@novaon.net',
  'sebnguyen1108@gmail.com',
  '360boutique.tmdt02@gmail.com'
]

export const keyword_tag_fixed_list = [
  'vuducminhdev07',
  'ads.atosa14@gmail.com',
  'loikhtn@gmail.com',
  '0934824608'
]

export const boost_campaign_fixed_list = [
  'vuducminhdev07',
  'ads.atosa14@gmail.com',
  'tranngoctan18@gmail.com',
  'lieutt124@gmail.com',
  'commerce@novaon.net',
  'thanhhangxd14@gmail.com',
  'cskh.atosavietnam@gmail.com'
]

export const group_campaign_advanced_list = [
  'vuducminhdev07',
  'curravn@gmail.com',
  'atoxon@atosa.asia',
  'ads.atosa14@gmail.com',
  'cskh.atosavietnam@gmail.com'
]

export const show_x_id_fixed_list = [
  'vuducminhdev07',
  'ads.atosa14@gmail.com',
]

export const auto_condition_action_fixed_list = [
  'vuducminhdev07',
  'ads.atosa14@gmail.com',
  'cskh.atosavietnam@gmail.com',
  'hanayuki1982@gmail.com',
  'vuxuanthuynd@gmail.com',
  'vuthilanchi2812@gmail.com'
]

export const new_buttons_fixed_list = [
  'vuducminhdev07',
  'ads.atosa14@gmail.com',
  'cskh.atosavietnam@gmail.com',
  'theanh0512@gmail.com'
]

export const restricted_keyword_fixed_list = [
  'vuducminhdev07',
  '0934824608',
  'nghiemchihuy@gmail.com',
  'hunganh.tmdt@haianhgroup.vn'
]

export const filter_by_categories_fixed_list = [
  'nguyenhuehrc@gmail.com',
  'hanhhue29091994@gmail.com',
  'vuducminhdev07'
]

export const advanced_auto_condition_action_fixed_list = [
  // 'vuducminhdev07',
  'e-commerce@smilee.vn',
  'smileehn.ecom@gmail.com',
  'kimngann1603@gmail.com',
  'dactungphi2111@gmail.com',
  'anhkevin1996@gmail.com',
  'ngocanhh11022@gmail.com',
  'chungle.2998@gmail.com',
  '21050789@vnu.edu.vn',
  'trinhlonggiang@gmail.com'
]

export const custom_report_fixed_list = [
  'vuducminhdev07',
  'ads.atosa14@gmail.com',
  'cskh.atosavietnam@gmail.com',
  'theanh0512@gmail.com',
  'ducphuluatsu@gmail.com'
]

export const custom_monthly_report_fixed_list = [
  'vuducminhdev07',
  'moonphan2000@gmail.com'
]

export const after_n_char_fixed_list = [
  'vuducminhdev07',
  'dangthikhanhle@gmail.com'
]

export const atosa_ai_fixed_list = [
  'vuducminhdev07',
  'ads.atosa14@gmail.com',
  'cskh.atosavietnam@gmail.com',
  'minhbt@atosa.asia',
  'packing.boxmall@gmail.com',
  'nguyenthiphu.nuce@gmail.com',
  'thanhsang8872405@gmail.com',
  "hoangluongtmu@gmail.com",
  "thanhsang8872405@gmail.com",
  "hai.luutuan197@gmail.com",
  "congionho20@gmail.com",
  "nguyenanhtuhp1987@gmail.com",
  "hieuliem1007@gmail.com",
  "thanhdatzxc220903@gmail.com",
  "omusevn.ecom@gmail.com",
  "vhthuong2708@gmail.com",
  "manhle12892@gmail.com",
  "phamhoanganhcnt@gmail.com",
  "vuminhphuoc",
  "phidactung@gmail.com",
  "hamabeo98hy@gmail.com",
  "quannd233@gmail.com",
  "vy.vh20@gmail.com",
  "nhatnamnguyen.jsc@gmail.com",
  "phamdinhdung7411@gmail.com",
  "ngan.nguyen@cocolux.com",
  "theanh0512@gmail.com",
  "phuonganh231193@gmail.com",
  "duykhanh.56cg2@gmail.com",
  "anhthi99td@gmail.com",
  "anhthi99td@gmail.com",
  "phuonganh231193@gmail.com",
  "phamdung130920@gmail.com",
  "nhatnamnguyen.jsc@gmail.com",
  "quan.nd@maxcare.com.vn",
  "0399078558_hieuliem.anhtuan@gmail.com",
  "congtytnhhthoitranglily@gmail.com",
  "khacduong20@gmail.com",
  "buihien.2708@gmail.com",
  "vtctuan199x@gmail.com",
  "hoangluongtmu@gmail.com",
  "kydopal@gmail.com",
  "levannapa90@gmail.com",
  "hieuliem1007@gmail.com",
  "ducdien.aof@gmail.com",
  "Hoanglinhvu90@gmail.com",
  "phidactung@gmail.com",
  "quannd233@gmail.com",
  "dinhkien177@gmail.com",
  "nhatnamnguyen.jsc@gmail.com",
  "kieuoanh369@gmail.com",
  "phamdinhdung7411@gmail.com",
  "thanh77462@gmail.com",
  "sieuthionline2439@gmail.com",
  "vukhanhtung82@gmail.com",
  "xuanvu210@gmail.com",
  "congtytnhhthoitranglily@gmail.com",
  "ntxngoc@yahoo.com",
  "hoangnv230892@gmail.com",
  "longtong0810@gmail.com",
  "khacduong20@gmail.com",
  "buihien.2708@gmail.com",
  "vtctuan199x@gmail.com",
  "ngan.nguyen@cocolux.com",
  "vanphuc1002@gmail.com",
  "trandinhnhatkhiem@gmail.com",
  "vquangvan001@gmail.com",
  "phucnguyenpr.com@gmail.com",
  "vuthilanchi2812@gmail.com",
  "hauluong6383@gmail.com",
  "thietbiytehaoanh@gmail.com"
]

export const always_ongoing_fixed_list = [
  'vuducminhdev07',
  'ads.atosa14@gmail.com',
  'cskh.atosavietnam@gmail.com',
  'nguyenkhai.vns@gmail.com'
]



// WEBPACK FOOTER //
// ./src/addon/fixed_list.js